<template>
    <van-popup v-if="selectApprovalPopupShow" :value="selectApprovalPopupShow" z-index="100" :close-on-click-overlay="false"
               :style="{ height: '100vh',width: '100vw', background: 'rgba(0,0,0,.3)' }" overlay-class="custom_popup" position="right">
        <div class="select_approval_wrap" v-loading="loading">
            <div class="select_approval_top">
                <div class="returnNavBar">
                    <div class="returnNavBarLeft" @click="handleClickClose">
                        <van-icon  name="arrow-left" />
                        <span class="normal_title">返回</span>
                    </div>
                    <div class="checked_arr">
                        <van-checkbox icon-size="16px"    v-model="allChecked" @click="handleChangeAllCheck()" shape="square"><span>全选</span></van-checkbox>
                    </div>
                </div>
                <div class="search_wrap">
                    <van-search v-model="searchForm.keyword"  placeholder="请输入需要查询的内容"  @clear="handleClickSearch" @search="handleClickSearch"></van-search>
                    <div class="approval_type_search ellipsis" @click="approvalTypePopupShow = true">
                        <span class="ellipsis text" v-if="searchForm.approval_type_ids.length" v-text="approvalSetTypeList.filter(item => searchForm.approval_type_ids.indexOf(item.approval_set_id) > -1).map(map => map.name).join(',')"></span>
                        <span v-else>请选择审批类型</span>
                        <i class="el-icon-caret-bottom"></i>
                    </div>
                </div>
            </div>
            <div class="relate_approval_tab">
                <span @click="handleClickApprovalTab(item.value)" v-for="item in approvalTabList" v-text="item.name" :class="item.value == searchForm.action ? 'active' : ''"></span>
            </div>
            <div class="select_approval_bottom">
                <van-checkbox-group  v-model="selectionIds">
                    <ul v-infinite-scroll="onLoadList">
                        <li v-for="item in tableData">
                            <div class="top">
                                <van-checkbox icon-size="16px"  :name="item.approval_id" @click="handleChangeCheck(item)" shape="square"></van-checkbox>
                                <span class="title ellipsis"  v-text="item.approval_set_name"></span>
                                <span class="id_num link-label ellipsis">ID:{{item.approval_id}}</span>
                                <span class="approval_status approval_status_1">已通过</span>
                            </div>
                            <div class="bottom">
                               <span class="user_head" @click="handleClickUserDetail('user_detail',{uid:item.user.id})">
                                  <img :src="item.user.avatar ? item.user.avatar : defaultImg" alt="">
                                  <span class="ellipsis">{{item.user.name}}</span>
                               </span>
                                <span class="time">
                                    申请时间：{{item.created_at}}
                                </span>
                            </div>
                            <div class="overview_list" v-if="item.overview_fields && item.overview_fields.length > 0">
                                <OverviewFields :overviewFields="item.overview_fields"   />
                            </div>
                        </li>
                    </ul>
                </van-checkbox-group>
            </div>

            <div class="select_approval_btn">
                <van-button  @click="handleClickConfirm"  :disabled="BtnDisabled"  type="info" size="small" >确定</van-button>
            </div>

            <van-popup v-if="approvalTypePopupShow" :value="approvalTypePopupShow" @click-overlay="handleClickTypeClose"	 z-index="100" :close-on-click-overlay="true"  :style="{ height: '60vh',width: '100vw', }" overlay-class="custom_popup" position="bottom">
                <van-checkbox-group v-model="searchForm.approval_type_ids">
                    <van-cell-group>
                        <van-cell v-for="(item, index) in approvalSetTypeList"   clickable :key="item.approval_set_id"   :title="item.name"  @click="toggleApprovalType(index)">
                            <template #right-icon>
                                <van-checkbox :name="item.approval_set_id" ref="checkboxes" />
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-checkbox-group>
            </van-popup>

            <userDetailDialog  v-if="userDetailPopupShow" :userDetailPopupShow.sync="userDetailPopupShow"  :userId="userDetailId" />

        </div>
    </van-popup>
</template>

<script>
import {getApprovalType,getRelateApproval,ProjectManageRelate} from "@/api/index.js"
import {pagination} from '@/mixins'
import {formatDate} from "@/utils";
import userDetailDialog from "@/components/mComponents/userDetailDialog";
import OverviewFields from "@/components/pComponents/overviewFields.vue";
export default {
    name: "select_approval",
    components: {userDetailDialog,OverviewFields},
    props: {
        selectApprovalPopupShow: {
            type: Boolean,
            default: false
        },
        selectData:{
            type:Array,
            default:()=>[]
        },
        projectId: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            defaultImg: require('@/assets/images/default.jpg'),
            loading:false,
            searchForm:{
                keyword:'',
                action:'initiated_by_me',
                approval_type_ids:[]
            },
            approvalTabList:[
                {value:'initiated_by_me',name:'已发起'},
                {value:'already_handled_by_me',name:'已处理'},
                {value:'received_by_me',name:'已收到'},
            ],
            BtnDisabled:false,
            tableData:[],
            selectionIds:[], //选中的id
            multipleSelection:[],//选中的数据
            allChecked:false,
            userDetailPopupShow:false,
            userDetailId:0,
            approvalTypePopupShow:false,
            approvalSetTypeList:[]
        };
    },
    mixins: [pagination],
    created() {
        this.multipleSelection = JSON.parse(JSON.stringify(this.selectData))
        this.selectionIds = this.multipleSelection.map(item=>item.approval_id)
        this.getApprovalType()
        this.getTableData()
    },
    methods: {
        toggleApprovalType(index){
            this.$refs.checkboxes[index].toggle();
        },
        // 获取可选的审批类型
        getApprovalType(){
            let postData = {
                approval_types:{
                    controls:[
                        'control_payable'
                    ],
                    type:[
                        'purchase'
                    ]
                }
            }
            getApprovalType(postData).then(res => {
                if (res.code === 200) {
                    const {data} = res
                    this.approvalSetTypeList = data
                }
            })
        },

        handleChangeAllCheck(){
            if(this.allChecked){
                this.selectionIds = this.tableData.map(item=>item.approval_id)
                this.multipleSelection = JSON.parse(JSON.stringify(this.tableData))
            }else{
                this.selectionIds = []
                this.multipleSelection = []
            }
        },
        handleChangeCheck(item){
            if(this.selectionIds.includes(item.approval_id)){
                this.multipleSelection.push(item)
            }else{
                this.multipleSelection.splice(this.multipleSelection.findIndex(item=>item.approval_id == item.approval_id),1)
            }
        },
        handleClickUserDetail(uid){
            this.userDetailId = uid
            this.userDetailPopupShow = true
        },
        handleClickApprovalTab(value){
            this.searchForm.action = value
            this.handleClickSearch()
        },
        handleClickTypeClose(){
          this.approvalTypePopupShow = false
          this.handleClickSearch()
        },
        handleClickSearch(){
            this.tableData = []
            this.pagination.pageNum = 1
            this.getTableData()
        },
        onLoadList(){
            if(this.pagination.total == this.tableData.length){
                return false
            }
            if(this.loading == false){
                this.getTableData();
            }
        },
        getTableData(){
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword:this.searchForm.keyword,
                action: this.searchForm.action,
                approval_set_ids: this.searchForm.approval_type_ids,
                approval_status:1,
                approval_types:{
                    controls:[
                        'control_payable'
                    ],
                    type:[
                        'purchase'
                    ]
                }
            }
            this.loading = true
            getRelateApproval(postData).then(res => {
                if (res.code === 200) {
                    let {data, total} = res.data
                    this.tableData =  this.tableData.concat(data)
                    this.pagination.total = total
                    this.pagination.pageNum++;
                }
                this.loading = false
            })
        },

        handleClickConfirm() {
            if(this.multipleSelection.length == 0){
                this.$toast('请选择审批')
                return false
            }
            let postData = {
                id: this.projectId,
                relate_type:'approval',
                sync:[],
                relate:this.multipleSelection.map((item)=>{
                    return {
                        relate_id:item.approval_id,
                        relate_num:'',
                        approval_set_name:item.approval_set_name
                    }
                })
            }
            this.BtnDisabled = true;
            ProjectManageRelate(postData).then(res => {
                if (res.code === 200) {
                    this.$toast(res.message)
                    this.$emit('success',this.multipleSelection)
                    this.$emit("update:selectApprovalPopupShow", false)
                } else {
                    this.BtnDisabled = false;
                }
            }).catch(() => {
                this.BtnDisabled = false;
            })
        },
        handleClickClose(){
            this.$emit("update:selectApprovalPopupShow", false)
        },

    },
}
</script>

<style  lang="scss" scoped>
@import "@/styles/m_style/project_management.scss";
</style>